import { Navigate, Route, Routes } from "react-router";
import { Layout, LAST_PROJECT_KEY } from "./components/Layout";
import { PageLoading } from "./components/Spinner";
import { useProjects } from "./api/queries";
import { RequireAuth, UnauthorizedWatcher, useCurrentUser } from "./lib/auth";
import { BoardPage } from "./pages/BoardPage";
import { LoginPage } from "./pages/LoginPage";
import { MonitorPage } from "./pages/MonitorPage";
import { NewProjectPage } from "./pages/NewProjectPage";
import { ProposalsPage } from "./pages/ProposalsPage";
import { RichDiffPage } from "./pages/RichDiffPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TaskPeek } from "./pages/TaskPeek";
import { AccountSettings } from "./pages/settings/AccountSettings";
import { Link } from "react-router";

export function App() {
  return (
    <>
      <UnauthorizedWatcher />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* Opens in its own window: no sidebar. */}
        <Route
          path="/p/:pid/tasks/:tid/rich-diff"
          element={
            <RequireAuth>
              <RichDiffPage />
            </RequireAuth>
          }
        />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<HomeRedirect />} />
          <Route path="projects/new" element={<NewProjectPage />} />
          <Route path="monitor" element={<MonitorPage />} />
          <Route
            path="account"
            element={
              <div className="page page-narrow">
                <h1 className="page-title">Account</h1>
                <AccountSettings />
              </div>
            }
          />
          <Route path="p/:pid" element={<BoardPage />}>
            <Route path="tasks/:tid" element={<TaskPeek />} />
          </Route>
          <Route path="p/:pid/proposals" element={<ProposalsPage />} />
          <Route path="p/:pid/settings" element={<SettingsPage />} />
          <Route path="p/:pid/settings/:section" element={<SettingsPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

function HomeRedirect() {
  const { data: projects, isLoading } = useProjects();
  const me = useCurrentUser();
  if (isLoading) return <PageLoading />;
  if (!projects || projects.length === 0) {
    return (
      <div className="page page-narrow empty-state">
        <h1 className="page-title">No projects yet</h1>
        {me.role === "admin" ? (
          <>
            <p className="muted">Create a project to get a board with the default workflow.</p>
            <Link to="/projects/new" className="btn btn-primary">
              New project
            </Link>
          </>
        ) : (
          <p className="muted">Ask an admin to create a project for you.</p>
        )}
      </div>
    );
  }
  let last: string | null = null;
  try {
    last = localStorage.getItem(LAST_PROJECT_KEY);
  } catch {
    /* ignore */
  }
  const target = projects.find((p) => p.id === last) ?? projects[0];
  return <Navigate to={`/p/${target.id}`} replace />;
}

function NotFound() {
  return (
    <div className="page page-narrow empty-state">
      <h1 className="page-title">Page not found</h1>
      <Link to="/">Go home</Link>
    </div>
  );
}
